import getApiClient from '@/plugins/api-client'
import planPeriodicities from '@/util/planPeriodicities'

export default {
  loadPlan: function () {
    const api = getApiClient(this.$store)
    const planId = this.$route.params.id

    api.get(`plans/${planId}`)
      .then(result => {
        this.plan = result.data
      })
      .catch(error => {
        this.error = error
      })
  },

  getPlanPeriodicityLabel (periodicity) {
    return planPeriodicities.filter(item => {
      return item.code === periodicity
    })[0]?.label
  },
}
